import React from 'react';
import ReactDOM from 'react-dom/client';
import './style/index.scss';
import App from './App';

 
//theme
import "primereact/resources/themes/lara-light-indigo/theme.css"; 
import "primereact/resources/primereact.min.css"; 
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


